import React from 'react';
import useStyle from './filterBar.style';
import SelectCatProduits from './SelectCatProduit';
import RebondProductsCheckbox from '../../components/organisms/filters/RebondProductsCheckbox';
import PriceSlider from '../../components/organisms/filters/PriceSlider';
import SearchProductInput from '../../components/organisms/filters/SearchProductInput';
import ResetFiltersButton from '../../components/organisms/filters/ResetFiltersButton';
import usePublicShop from 'hooks/usePublicShop';
import { DisplaySwitch } from '../../components/molecules/FilterBar/DisplaySwitch';
import { MultipleSelect } from 'components/atoms/Inputs/MultipleSelect';
import { Modal } from 'components/organisms/Modals/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ProductDisplayList } from '../../types/ui';
import { getProductFilters } from 'store/selectors/productFilter.selectors';
import { displayProductList } from '../../store/actions/ui.actions';
import { selectProductDisplay } from 'store/selectors/ui.selectors';
import { IconLabel } from 'components/atoms/Texts/IconLabel';
import { GetCategoriesWithNameQuery } from '../../graphql/generated/graphql';
import { useQuery } from '@apollo/client';
import { QUERY_CATEGORIES } from '../../graphql/query/product/categories';
import { getProductCategoriesFromQuery } from '../../helpers/transformApiResponse/product';

const FilterBar = () => {
  const dispatch = useDispatch();
  const { isPublicShop } = usePublicShop();
  const { productsFilters } = useSelector(getProductFilters);
  const display = useSelector(selectProductDisplay);
  const classes = useStyle({ isPublicShop });
  const { loading, error, data } = useQuery<GetCategoriesWithNameQuery>(
    QUERY_CATEGORIES
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Erreur...</p>;

  const categories = getProductCategoriesFromQuery(data.categorieproduits.data);

  const onClick = (value: boolean) => {
    const displayProduct: ProductDisplayList = value ? 'Mosaique' : 'List';
    dispatch(displayProductList(displayProduct));
  };

  return (
    <div className={classes.container}>
      <div className={classes.root}>
        <SearchProductInput />
        <DisplaySwitch
          defaultValue={display === 'Mosaique' ? true : false}
          onClick={onClick}
        />
        <Modal
          modalHead="Plus de filtres"
          triggerButton={
            <div>
              <IconLabel icon="Filter" label="Plus de filtres" />
              <MultipleSelect
                filtersboxes={[
                  productsFilters.category === '0'
                    ? 'Toutes les familles'
                    : categories.find(
                        categorie => categorie.id === productsFilters.category
                      )?.name,
                  productsFilters.price + ' € max',
                  productsFilters.rebond
                    ? 'Uniquement les ventes additionnelles'
                    : 'Tous les produits'
                ]}
              />
            </div>
          }
          width="small"
        >
          <RebondProductsCheckbox />
          <PriceSlider />
          <SelectCatProduits categories={categories} />
          <ResetFiltersButton />
        </Modal>
      </div>
    </div>
  );
};

export default FilterBar;
